import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, Grid, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './style.css';

const predefinedColors = [
  '#0079bf', 
  '#a36c1fff',
  '#519839', 
  '#a13f2bff',
  '#89609e', 
  '#af4c7cff', 
  '#409790ff',
  '#747b80ff',
];
// 'linear-gradient(45deg, #ffffff, #34854a);', 
//   'linear-gradient(45deg, #5b6165, #ffffff);', 

const BackgroundColorPicker = ({ open, onClose, currentColor, onColorChange }) => {
  const [selectedColor, setSelectedColor] = useState(currentColor || '#ccd1d9');

  const handleColorSelect = (color) => {
    setSelectedColor(color);
  };

  const handleSave = () => {
    onColorChange(selectedColor);
    onClose();
  };

  const handleRemoveColor = () => {
    onColorChange(null);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        className: 'background-color-picker-dialog',
      }}
    >
      <DialogTitle 
        className='background-color-picker-title'
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Escolher cor de fundo do quadro
        </Typography>
        <IconButton 
          onClick={onClose}
          className='background-color-picker-close-btn'
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ p: 1 }}>
          <Typography 
            variant="subtitle1" 
            gutterBottom 
            className='background-color-picker-subtitle'
          >
            Cores predefinidas
          </Typography>
          <Grid container spacing={2} sx={{ mb: 4 }}>
            {predefinedColors.map((color) => (
              <Grid item key={color}>
                <Box
                  className={`background-color-option  ${selectedColor === color ? 'selected' : ''}`}
                  sx={{
                    width: 48,
                    height: 48,
                    background: color,
                    border: selectedColor === color ? '3px solid #009373' : '2px solid var(--color-option-border, #ddd)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }
                  }}
                  onClick={() => handleColorSelect(color)}
                />
              </Grid>
            ))}
          </Grid>
          
          {/* Preview section */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="subtitle1" 
              gutterBottom 
              className='background-color-picker-preview-title'
            >
              Visualização
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: 80,
                background: selectedColor || '#ccd1d9',
                borderRadius: '8px',
                border: '1px solid var(--preview-border, #ddd)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 1
              }}
            >
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: 500,
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                }}
              >
                Cor de fundo do quadro
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>
            <Button 
              onClick={handleRemoveColor} 
              variant="outlined" 
              color="error"
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                px: 3,
                '&:hover': {
                  backgroundColor: 'rgba(211, 47, 47, 0.1)'
                }
              }}
            >
              Remover cor personalizada
            </Button>
            <Button 
              onClick={handleSave} 
              variant="contained"
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                px: 3,
                backgroundColor: '#009373',
                '&:hover': {
                  backgroundColor: '#007a5e'
                }
              }}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BackgroundColorPicker;
